<template>
    <div>
        <div class="modal fade modal-body-fixed" id="modalReviews" tabindex="-1" aria-labelledby="reviesMedico" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <button type="button" class="close rfs-10 mr-2 mt-2 mb-1 text-right" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="modal-header mt-n4" v-if="medico">
                        <div class="d-flex justify-content-between w-100 align-items-start">
                            <div class="d-flex justify-content-between align-items-center">
                                <img :src="medico.listFoto[1]" width="80" height="80" class="img-fluid rounded-circle mr-3 img-heading" :title="medico.fullName"/>
                                <h5 class="modal-title w-100" id="reviesMedico" v-if="medico">
                                    <span class="d-block">{{ medico.fullName }}</span>
                                    <span class="d-block text-muted rfs-6">Recensioni dei pazienti</span>
                                    <span v-if="mediaGenerale">
                                        <stars-component v-model="mediaGenerale" container-class="mb-0 d-inline-block" />
                                        <small class="text-muted font-italic rfs-5 d-inline-block">{{ totalItems }} recensioni</small>
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row py-4 text-center" v-if="onLoading && !items.length">
                            <div class="col">
                                <i class="fas fa-sync-alt fa-2x fa-spin"></i>
                                <span class="sr-only">Caricamento...</span>
                            </div>
                        </div>
                        <div class="row" v-if="medico">
                            <div class="col-12" v-for="(q, k) in items" :key="k">
                                <hr class="my-2" v-if="k > 0">

                                <div class="py-2 review-wrap">
                                    <div><strong>{{ q.paziente }}</strong> - {{ q.citta }} <span class="text-capitalize text-muted small ml-2">{{ q.dataLabel }}</span></div>
                                    <div class="py-2" v-if="target == 'Clinica'">
                                        <span class="text-muted">Medico: {{ q.medicoFullName }}</span>
                                    </div>
                                    <stars-component v-model="q.mediaVotoMedico"  />
                                    <p class="row col-12 col-lg-11 mt-n2">{{ q.commento_medico }}</p>

                                    <div class="row mt-4" v-if="q.risposta">
                                        <div class="col-2 pr-0 text-right">
                                            <img :src="medico.listFoto[1]" width="40" height="40" class="img-fluid rounded-circle img-reviews" :title="medico.fullName"/>
                                        </div>
                                        <div class="col-10">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="modal-title w-100 text-muted">
                                                    Risposta del <strong>{{ medico.fullName }}</strong>
                                                </div>
                                            </div>
                                            <p class="text-muted mt-2 font-italic">{{ q.risposta.risposta }}</p>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between" v-if="medico">
                        <button data-dismiss="modal" class="btn btn-outline-secondary ml-auto">chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StarsComponent from '../../components/StarsComponent.vue';
export default {
    components: { StarsComponent },

    props: {

    },
    data: function() {
        return {
            medico: null,
            idMedico: null,
            target: null,
            currentPage: 1,
            nextPage: false,
            onLoading: false,
            totalItems: 0,
            items: [],
            mediaGenerale: null,
        };
    },
    computed: {

    },
    watch: {
    },
    mounted() {
    },
    methods: {
       show(idMedico, mediaGenerale, target) {
            this.medico = null;
            this.currentPage = 1;
            this.nextPage = false;
            this.totalItems = 0;
            this.items = [];
            this.idMedico = idMedico;
            this.mediaGenerale = mediaGenerale;
            this.target = target;

            $(this.$el).find('#modalReviews').modal('show');
            return this.requestReviews();
       },

        goNextPage: function() {
            this.currentPage++;
            return this.requestReviews();
        },
       requestReviews: function() {
            this.onLoading = true;
            httpRequest(api_url + 'frontend/medico/reviews', {id: this.idMedico, target: this.target}, {showLoader: false}).then(onResult => {
                if (!onResult.result) {
                    return; //??
                }

                this.medico = onResult.data.medico;
                this.totalItems = onResult.data.totalItems;
                this.nextPage = onResult.data.next_page ? true : false;

                for(const k in onResult.data.items) {
                    this.items.push(onResult.data.items[k]);
                }

            }).finally(() => {
                this.onLoading = false;
            });
       }
    }
};
</script>
<style lang="scss" scoped>
.img-heading {
    width: 80px;
    height: 80px;
    min-width: 80px;
    min-height: 80px;
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 1px 8px 10px -6px #6c757d;
    -o-object-fit: cover;
    object-fit: cover;
}
.img-risposta {
    width: 45px;
    height: 45px;
    min-width: 45px;
    min-height: 45px;
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 1px 8px 10px -6px #6c757d;
    -o-object-fit: cover;
    object-fit: cover;
}
</style>
